import { type Action } from 'redux';
import {
  ActionsObservable,
  combineEpics,
  ofType,
  StateObservable,
} from 'redux-observable';
import { EMPTY } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';

import { SUBSCRIBE_RECENT_TRADE, UNSUBSCRIBE_OB_RT } from 'actionTypes/socket';
import {
  PUBLIC_SOCKET_CHANNELS,
  PUBLIC_SOCKET_OUTGOING_MESSAGE_TYPES,
} from 'constants/publicSocket';
import { selectedProductSelector } from 'selectors/tradeSelectors';
import IState from 'types/Istore';
import { AggTradesPayload } from 'types/ITrade';
import { getRecentTrades } from 'variableStore/actions';

import { publicWsSubject } from './publicSocket';
import { payloadGenerator } from './socket';

const recentTradeChannel = symbols =>
  publicWsSubject.multiplex(
    () =>
      payloadGenerator(
        PUBLIC_SOCKET_OUTGOING_MESSAGE_TYPES.SUBSCRIBE,
        PUBLIC_SOCKET_CHANNELS.AGGREGATED_TRADES,
        symbols
      ),
    () =>
      payloadGenerator(
        PUBLIC_SOCKET_OUTGOING_MESSAGE_TYPES.UNSUBSCRIBE,
        PUBLIC_SOCKET_CHANNELS.AGGREGATED_TRADES,
        symbols
      ),
    message => message.type === PUBLIC_SOCKET_CHANNELS.AGGREGATED_TRADES
  );

export const subscribeRecentTradeEpic = (
  action$: ActionsObservable<Action>,
  state$: StateObservable<IState>
) =>
  action$.pipe(
    ofType(SUBSCRIBE_RECENT_TRADE),
    mergeMap(action => {
      return recentTradeChannel([action.payload]).pipe(
        takeUntil(action$.ofType(UNSUBSCRIBE_OB_RT)),
        catchError(err => {
          console.error('Recent', err);
          return EMPTY;
        })
      );
    }),
    map((message: AggTradesPayload) => {
      const selectedProduct = selectedProductSelector(state$.value);
      return getRecentTrades(message, selectedProduct?.symbol);
    })
  );

export default combineEpics(subscribeRecentTradeEpic);
